import { render, staticRenderFns } from "./dictionariesCategory.vue?vue&type=template&id=f1bd8fb6&scoped=true&"
import script from "./dictionariesCategory.vue?vue&type=script&lang=js&"
export * from "./dictionariesCategory.vue?vue&type=script&lang=js&"
import style0 from "./dictionariesCategory.vue?vue&type=style&index=0&id=f1bd8fb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bd8fb6",
  null
  
)

export default component.exports